import React from "react";
import { Route, Routes } from "react-router-dom";
import OoraJobLogs from "../Components/Oora Reports/ooraReportsList";
import ViewOoraJobLogs from "../Components/Oora Reports/ooraReportsView";

const OoraJobLogsRoutes = () => {
  return (
    <Routes>
      <Route path="/oora-job-logs" element={<OoraJobLogs />} />
      <Route path="/oora-job-logs/view/:job_id" element={<ViewOoraJobLogs />} />
    </Routes>
  );
};

export default OoraJobLogsRoutes;